import React from "react";
import classnames from "classnames";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";

import EgwWebFont from "@/shared/assets/EgwWebFont";
import IconButton from "@/shared/components/IconButton/IconButton";

import styles from "./ThemeButton.module.scss";

const ThemeButton = ({
  isLightDarkModesOnly,
  active,
  color,
  className,
  isDarkTheme,
  onClick,
}) => {
  const { t } = useSharedTranslation();

  const title = isLightDarkModesOnly
    ? (t("theme") + " " + (isDarkTheme ? t("dayMode") : t("darkMode")))
    : t("theme");

  return (
    <IconButton
      bordered
      className={classnames(className, styles["btn"])}
      active={active}
      color={color}
      icon={EgwWebFont["theme-select"]}
      title={title}
      onClick={onClick}
    >
      <span className={classnames(styles["icon"], {
        [styles["is-dark-theme"]]: isDarkTheme,
      })} />
    </IconButton>
  )
};

export default ThemeButton;
